// In-memory mirror of the authenticated user's identity and role.
//
// Populated by AuthContext from the backend-validated /api/auth/check response
// so identity/role reads stay correct even if localStorage is cleared.

export type AuthSnapshot = {
    /** Numeric User primary key. */
    userId: number | null;
    /** Highest-priority role. */
    role: string | null;
    /** Full ordered list of roles. */
    roles: string[];
    /** Whether the user has accepted terms & conditions (per the auth-check response). */
    termsAccepted: boolean;
    /** Backend-validated: user has linked Google OAuth credentials (Drive/Calendar). */
    googleConnected: boolean;
    /** Effective Pre-Read create capability from /api/auth/check. */
    internalCoachPreReadEnabled: boolean;
    /** Effective add/manage student-athlete capability from /api/auth/check. */
    manageStudentAthletesEnabled: boolean;
};

let snapshot: AuthSnapshot = {
    userId: null,
    role: null,
    roles: [],
    termsAccepted: false,
    googleConnected: false,
    internalCoachPreReadEnabled: false,
    manageStudentAthletesEnabled: false,
};

export function setAuthSnapshot(next: AuthSnapshot): void {
    snapshot = next;
}

export function clearAuthSnapshot(): void {
    snapshot = {
        userId: null,
        role: null,
        roles: [],
        termsAccepted: false,
        googleConnected: false,
        internalCoachPreReadEnabled: false,
        manageStudentAthletesEnabled: false,
    };
}

export function getAuthUserId(): number | null {
    return snapshot.userId;
}

export function getAuthRole(): string | null {
    return snapshot.role;
}

export function getAuthRoles(): string[] {
    return snapshot.roles;
}

export function getAuthTermsAccepted(): boolean {
    return snapshot.termsAccepted;
}

export function getGoogleConnected(): boolean {
    return snapshot.googleConnected;
}

export function getAuthInternalCoachPreReadEnabled(): boolean {
    return snapshot.internalCoachPreReadEnabled;
}

export function getAuthManageStudentAthletesEnabled(): boolean {
    return snapshot.manageStudentAthletesEnabled;
}
